class CustomSlider extends HTMLElement {
  constructor() {
    super();
    this.items = null;
    this.originalItems = null;
    this.dots = null;
    this.itemsPerRow = 4;
    this.minItemsPerRow = 2;
    this.minItemsAmount = 12;
    this.carouselContainer = this.querySelector(
      '.custom-slider-container-list',
    );
    this.isInfinite = this.getAttribute('data-is-infinite') === 'true';
    this.nextBtn = this.querySelector('.custom-slide-next');
    this.prevBtn = this.querySelector('.custom-slide-prev');

    this.nextBtn?.addEventListener('click', this.handleNextSlide);
    this.prevBtn?.addEventListener('click', this.handlePreviousSlide);
    this.carouselContainer?.addEventListener('scroll', this.handleOnScroll);
    this.buildSlider();
    this.addEventListener('build:slider', this.buildSlider);
    window.addEventListener('resize', this.onDocumentRezise);
  }

  buildSlider = () => {
    this.originalItems = [...this.querySelectorAll('.custom-slide')].map(
      (item) => item.cloneNode(true),
    );
    this.items = this.querySelectorAll('.custom-slide');
    this.dots = this.querySelectorAll('.custom-slider-dot');
    this.itemsPerRow = Number(this.getAttribute('data-items-per-page')) || 4;
    this.minItemsPerRow =
      Number(this.getAttribute('data-min-items-per-page')) || 2;
    this.minItemsAmount =
      Number(this.getAttribute('data-min-items-amount')) || 12;
    this.carouselContainer = this.querySelector(
      '.custom-slider-container-list',
    );
    this.isInfinite = this.getAttribute('data-is-infinite') === 'true';
    if (!this.items?.length) {
      return;
    }
    if (this.isInfinite) {
      this.extendItemsForInfiniteSlider();
    }

    this.dots.forEach((dot) => {
      dot.addEventListener('click', this.onClickDot);
    });

    this.handleOnScroll();
  };

  onDocumentRezise = () => {
    if (this.isInfinite) {
      this.extendItemsForInfiniteSlider();
    }
    this.handleOnScroll();
    this.updateItemsAlignment();
  };

  handleOnScroll = () => {
    const previousScroll = this.carouselContainer?.scrollLeft ?? 0;
    const { primary, secondary } = this.getScrollsAmount();

    const primaryScrollAmount =
      primary *
      (document.body.offsetWidth > 765
        ? this.itemsPerRow
        : this.minItemsPerRow);
    const secondaryScrollAmount =
      secondary *
      (document.body.offsetWidth > 765
        ? this.itemsPerRow
        : this.minItemsPerRow);

    const resultCheck = Math.min(
      previousScroll % primaryScrollAmount,
      previousScroll % secondaryScrollAmount,
    );
    const maxScrollLeft =
      this.carouselContainer?.scrollWidth - this.carouselContainer?.clientWidth;

    const isMaxScroll =
      Math.abs(maxScrollLeft - this.carouselContainer?.scrollLeft) < 2;
    if (resultCheck < 2) {
      if (Math.abs(maxScrollLeft - this.carouselContainer?.scrollLeft) < 2) {
        if (this.isInfinite) {
          if (this.isFirefox()) {
            void this.carouselContainer.offsetWidth;
          }
          this.carouselContainer.scrollLeft = maxScrollLeft;
        }
        this.rotateItems({
          count:
            document.body.offsetWidth > 765
              ? this.itemsPerRow
              : this.minItemsPerRow,
        });
        if (
          this.isInfinite &&
          (this.isFirefox() || document.body.offsetWidth <= 765)
        ) {
          void this.carouselContainer.offsetWidth;
          this.carouselContainer.scrollLeft -= primaryScrollAmount;
        }
      } else if (this.carouselContainer?.scrollLeft === 0) {
        if (this.isInfinite) {
          this.carouselContainer.scrollLeft = 0;
        }
        this.rotateItems({
          count:
            (document.body.offsetWidth > 765
              ? this.itemsPerRow
              : this.minItemsPerRow) * -1,
        });
        if (this.isInfinite) {
          this.carouselContainer.scrollLeft = primaryScrollAmount;
        }
      }
      this.updateItemsAlignment();
    }
    const index = isMaxScroll
      ? this.dots.length - 1
      : Math.round(previousScroll / Math.min(primary, secondary)) || 0;
    this.dots?.forEach((dot, dotIndex) => {
      if (dotIndex === index) {
        dot.classList.add('dot-active');
      } else {
        dot.classList.remove('dot-active');
      }
    });
    this.updateButtonsState();
  };

  isFirefox = () => {
    const ua = navigator.userAgent.toLowerCase();
    const isSafari =
      ua.includes('safari') &&
      !ua.includes('chrome') &&
      !ua.includes('chromium') &&
      !ua.includes('android');
    const isFirefox = ua.includes('firefox');
    return isSafari || isFirefox;
  };

  updateButtonsState = () => {
    if (this.isInfinite) {
      return;
    }

    const scrollAmount =
      this.getScrollAmount() *
      (document.body.offsetWidth > 765
        ? this.itemsPerRow
        : this.minItemsPerRow);

    const maxScrollLeft =
      this.carouselContainer?.scrollWidth - this.carouselContainer?.clientWidth;

    this.nextBtn?.classList.remove('disabled-btn');
    this.prevBtn?.classList.remove('disabled-btn');

    if (Math.abs(maxScrollLeft - this.carouselContainer?.scrollLeft) < 2) {
      this.nextBtn?.classList.add('disabled-btn');
    }

    if (this.carouselContainer?.scrollLeft === 0) {
      this.prevBtn?.classList.add('disabled-btn');
    }

    if (
      Math.abs(
        this.carouselContainer?.scrollWidth -
          this.carouselContainer?.offsetWidth,
      ) < 2
    ) {
      this.nextBtn?.classList.add('disabled-btn');
      this.prevBtn?.classList.add('disabled-btn');
    }
  };

  onClickDot = (e) => {
    const el = e.currentTarget;
    const index = Number(el.getAttribute('data-index')) || 0;
    const left = this.getScrollAmount() * index;
    this.carouselContainer?.scroll({
      left,
      behavior: 'smooth',
    });
  };

  rotateItems = ({ count }) => {
    if (count === 0 || this.items.length === 0 || !this.isInfinite) return;

    if (count > 0) {
      const movingItems = [...this.items].splice(0, count);
      movingItems.forEach((item) => this.carouselContainer.appendChild(item));
    }

    if (count < 0) {
      const absCount = Math.abs(count);
      const movingItems = [...this.items].splice(-absCount, absCount);
      movingItems.forEach((item) =>
        this.carouselContainer.insertBefore(item, this.items[0] || null),
      );
    }

    this.items = this.querySelectorAll('.custom-slide');
  };

  extendItemsForInfiniteSlider = () => {
    const originalItems = [...this.originalItems];
    const originalLength = originalItems.length;

    if (originalLength === 0) {
      return;
    }

    const itemPerPage =
      document.body.offsetWidth > 765 ? this.itemsPerRow : this.minItemsPerRow;
    const minTotal = itemPerPage * 3;

    let paddedCount = Math.max(originalLength, minTotal);

    const remainder = paddedCount % itemPerPage;
    if (remainder !== 0) {
      paddedCount += itemPerPage - remainder;
    }

    const needed = paddedCount - originalLength;

    if (needed === 0) {
      return;
    }

    let clones = [];

    while (clones.length < needed) {
      const shuffled = [...originalItems].map((item) => item.cloneNode(true));
      // .sort(() => Math.random() - 0.5);

      for (const clone of shuffled) {
        if (clones.length > 0) {
          const lastClone = clones[clones.length - 1];
          if (lastClone.isEqualNode(clone) && originalItems.length > 1)
            continue;
        }
        clones.push(clone);
        if (clones.length >= needed) break;
      }
    }

    this.carouselContainer.innerHTML = '';
    originalItems.forEach((item) =>
      this.carouselContainer.appendChild(item.cloneNode(true)),
    );
    clones.forEach((clone) => this.carouselContainer.appendChild(clone));

    this.items = this.querySelectorAll('.custom-slide');
    if (window.AOS) {
      AOS.init();
    }
  };

  updateItemsAlignment = () => {
    const snapInterval =
      document.body.offsetWidth > 765 ? this.itemsPerRow : this.minItemsPerRow;

    this.items.forEach((item, index) => {
      item.style.scrollSnapAlign = index % snapInterval === 0 ? 'start' : '';
    });
  };

  handleNextSlide = () => {
    const previousScroll = this.carouselContainer?.scrollLeft ?? 0;
    const left =
      previousScroll +
      this.getScrollAmount() *
        (document.body.offsetWidth > 765
          ? this.itemsPerRow
          : this.minItemsPerRow);
    this.carouselContainer?.scroll({
      left,
      behavior: 'smooth',
    });
  };

  handlePreviousSlide = () => {
    const previousScroll = this.carouselContainer?.scrollLeft ?? 0;
    const left =
      previousScroll -
      this.getScrollAmount() *
        (document.body.offsetWidth > 765
          ? this.itemsPerRow
          : this.minItemsPerRow);
    this.carouselContainer?.scroll({
      left,
      behavior: 'smooth',
    });
  };

  getScrollAmount = () => {
    return this.carouselContainer.scrollWidth / this.items.length;
  };

  getScrollsAmount = () => {
    return {
      primary: this.items[0]?.offsetWidth || 0,
      secondary: this.carouselContainer?.scrollWidth / this.items?.length || 0,
    };
  };
}

if (!customElements.get('custom-slider')) {
  customElements.define('custom-slider', CustomSlider);
}

class CustomSliderMin extends HTMLElement {
  constructor() {
    super();
    this.items = null;
    this.originalItems = null;
    this.itemsPerRow = 4;
    this.minItemsPerRow = 2;
    this.carouselContainer = this.querySelector(
      '.custom-slider-container-list',
    );
    this.isInfinite = this.getAttribute('data-is-infinite') === 'true';
    this.nextBtn = this.querySelector('.custom-slide-next');
    this.prevBtn = this.querySelector('.custom-slide-prev');
    this.scrollTimeout = null;
    this.desktopItemsPerRow =
      Number(this.getAttribute('data-desktop-items-per-row')) || 4;
    this.mobileItemsPerRow =
      Number(this.getAttribute('data-mobile-items-per-row')) || 2;
  }

  connectedCallback() {
    this.nextBtn?.addEventListener('click', this.handleNextSlide);
    this.prevBtn?.addEventListener('click', this.handlePreviousSlide);
    this.carouselContainer?.addEventListener('scroll', () => {
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        this.handleOnScroll();
      }, 100);
    });
    this.buildSlider();
    this.addEventListener('build:slider', this.buildSlider);
    window.addEventListener('resize', this.onDocumentRezise);
  }

  buildSlider = () => {
    this.originalItems = [...this.querySelectorAll('.custom-slide')].map(
      (item) => item.cloneNode(true),
    );
    this.items = this.querySelectorAll('.custom-slide');
    this.itemsPerRow = Number(this.getAttribute('data-items-per-page')) || 4;
    this.minItemsPerRow =
      Number(this.getAttribute('data-min-items-per-page')) || 2;
    this.carouselContainer = this.querySelector(
      '.custom-slider-container-list',
    );
    this.isInfinite = this.getAttribute('data-is-infinite') === 'true';
    this.desktopItemsPerRow =
      Number(this.getAttribute('data-desktop-items-per-row')) || 4;
    this.mobileItemsPerRow =
      Number(this.getAttribute('data-mobile-items-per-row')) || 2;
    const currentItemsPerRow =
      document.body.offsetWidth > 765
        ? this.desktopItemsPerRow
        : this.mobileItemsPerRow;
    if (!this.items?.length) {
      return;
    }
    if (this.isInfinite && this.originalItems.length < currentItemsPerRow) {
      this.extendItemsForInfiniteSlider();
    }
    this.carouselContainer.scrollLeft =
      (this.carouselContainer?.scrollWidth -
        this.carouselContainer?.clientWidth) /
      2;
    this.handleOnScroll();
  };

  onDocumentRezise = () => {
    const currentItemsPerRow =
      document.body.offsetWidth > 765
        ? this.desktopItemsPerRow
        : this.mobileItemsPerRow;
    if (this.isInfinite && this.originalItems.length < currentItemsPerRow) {
      this.extendItemsForInfiniteSlider();
    }
    this.handleOnScroll();
    this.updateItemsAlignment();
  };

  handleOnScroll = () => {
    const previousScroll = this.carouselContainer?.scrollLeft ?? 0;
    const { primary, secondary } = this.getScrollsAmount();

    const primaryScrollAmount =
      primary *
      (document.body.offsetWidth > 765
        ? this.itemsPerRow
        : this.minItemsPerRow);
    const secondaryScrollAmount =
      secondary *
      (document.body.offsetWidth > 765
        ? this.itemsPerRow
        : this.minItemsPerRow);

    const resultCheck = Math.min(
      previousScroll % primaryScrollAmount,
      previousScroll % secondaryScrollAmount,
    );
    if (resultCheck < 2) {
      const maxScroll =
        this.carouselContainer.scrollWidth - this.carouselContainer.clientWidth;
      if (Math.abs(maxScroll - previousScroll) <= 2) {
        if (this.isFirefox()) {
          void this.carouselContainer.offsetWidth;
        }
        this.carouselContainer.scrollLeft = maxScroll;
        this.rotateItems({
          count:
            document.body.offsetWidth > 765
              ? this.itemsPerRow
              : this.minItemsPerRow,
        });
        if (this.isFirefox() || document.body.offsetWidth <= 765) {
          void this.carouselContainer.offsetWidth;
          this.carouselContainer.scrollLeft =
            previousScroll - primaryScrollAmount;
        }
      } else if (previousScroll === 0) {
        void this.carouselContainer.offsetWidth;
        this.carouselContainer.scrollLeft = 0;
        this.rotateItems({
          count:
            (document.body.offsetWidth > 765
              ? this.itemsPerRow
              : this.minItemsPerRow) * -1,
        });
        void this.carouselContainer.offsetWidth;
        this.carouselContainer.scrollLeft = primaryScrollAmount;
      }

      this.updateItemsAlignment();
      this.updateButtonsState();
    }
  };

  isFirefox = () => {
    const ua = navigator.userAgent.toLowerCase();
    const isSafari =
      ua.includes('safari') &&
      !ua.includes('chrome') &&
      !ua.includes('chromium') &&
      !ua.includes('android');
    const isFirefox = ua.includes('firefox');
    return isSafari || isFirefox;
  };

  updateButtonsState = () => {
    if (this.isInfinite) {
      return;
    }

    const scrollAmount =
      this.getScrollAmount() *
      (document.body.offsetWidth > 765
        ? this.itemsPerRow
        : this.minItemsPerRow);

    if (
      this.carouselContainer?.scrollWidth - scrollAmount ===
      this.carouselContainer?.scrollLeft
    ) {
      this.nextBtn?.parentElement.classList.add('disabled-btn');
      this.prevBtn?.parentElement.classList.remove('disabled-btn');
    }

    if (this.carouselContainer?.scrollLeft === 0) {
      this.nextBtn?.parentElement.classList.remove('disabled-btn');
      this.prevBtn?.parentElement.classList.add('disabled-btn');
    }

    if (
      this.carouselContainer?.scrollWidth ===
      this.carouselContainer?.offsetWidth
    ) {
      this.nextBtn?.parentElement.classList.add('disabled-btn');
      this.prevBtn?.parentElement.classList.add('disabled-btn');
    }
  };

  rotateItems = ({ count }) => {
    if (count === 0 || this.items.length === 0 || !this.isInfinite) return;

    if (count > 0) {
      const movingItems = [...this.items].splice(0, count);
      movingItems.forEach((item) => this.carouselContainer.appendChild(item));
    }

    if (count < 0) {
      const absCount = Math.abs(count);
      const movingItems = [...this.items].splice(-absCount, absCount);
      movingItems.forEach((item) =>
        this.carouselContainer.insertBefore(item, this.items[0] || null),
      );
    }

    this.items = this.querySelectorAll('.custom-slide');
  };

  extendItemsForInfiniteSlider = () => {
    const originalItems = [...this.originalItems];
    const originalLength = originalItems.length;

    if (originalLength === 0) {
      return;
    }

    const itemPerPage =
      document.body.offsetWidth > 765 ? this.itemsPerRow : this.minItemsPerRow;
    const minTotal =
      Math.round(this.carouselContainer?.clientWidth / this.getScrollAmount()) *
      2;

    let paddedCount = Math.max(originalLength, minTotal);

    const remainder = paddedCount % itemPerPage;
    if (remainder !== 0) {
      paddedCount += itemPerPage - remainder;
    }

    const needed = paddedCount - originalLength;

    if (needed === 0) {
      return;
    }

    let clones = [];

    while (clones.length < needed) {
      const shuffled = [...originalItems].map((item) => item.cloneNode(true));
      // .sort(() => Math.random() - 0.5);

      for (const clone of shuffled) {
        // if (clones.length > 0) {
        //   const lastClone = clones[clones.length - 1];
        //   if (lastClone.isEqualNode(clone) && originalItems.length > 1)
        //     continue;
        // }
        clones.push(clone);
        if (clones.length >= needed) break;
      }
    }

    this.carouselContainer.innerHTML = '';
    originalItems.forEach((item) =>
      this.carouselContainer.appendChild(item.cloneNode(true)),
    );
    clones.forEach((clone) => this.carouselContainer.appendChild(clone));

    this.items = this.querySelectorAll('.custom-slide');
    if (window.AOS) {
      AOS.init();
    }
  };

  updateItemsAlignment = () => {
    const snapInterval =
      document.body.offsetWidth > 765 ? this.itemsPerRow : this.minItemsPerRow;

    this.items.forEach((item, index) => {
      item.style.scrollSnapAlign = index % snapInterval === 0 ? 'start' : '';
    });
  };

  handleNextSlide = () => {
    const previousScroll = this.carouselContainer?.scrollLeft ?? 0;
    const scrollAmount =
      this.getScrollAmount() *
      (document.body.offsetWidth > 765
        ? this.itemsPerRow
        : this.minItemsPerRow);
    const left = previousScroll + scrollAmount;

    this.carouselContainer?.scroll({
      left,
      behavior: 'smooth',
    });
  };

  handlePreviousSlide = () => {
    const previousScroll = this.carouselContainer?.scrollLeft ?? 0;
    const scrollAmount =
      this.getScrollAmount() *
      (document.body.offsetWidth > 765
        ? this.itemsPerRow
        : this.minItemsPerRow);
    const left = previousScroll + scrollAmount * -1;

    this.carouselContainer?.scroll({
      left,
      behavior: 'smooth',
    });
  };

  getScrollAmount = () => {
    return this.carouselContainer?.scrollWidth / this.items?.length || 0;
  };

  getScrollsAmount = () => {
    return {
      primary: this.items[0]?.offsetWidth || 0,
      secondary: this.carouselContainer?.scrollWidth / this.items?.length || 0,
    };
  };
}

if (!customElements.get('custom-slider-min')) {
  customElements.define('custom-slider-min', CustomSliderMin);
}
